module.exports = __webpack_public_path__ + "static/media/image2.b0827465.JPG";